module.exports = "<app-loading-page-spinner *ngIf=\"loading\"></app-loading-page-spinner>\n<router-outlet *ngIf=\"!loading\"></router-outlet>\n"